<template>
  <pdl-dialog
    id="customization-share-email-dialog"
    v-model:visible="isVisible"
    :title="$t('projectOne.config.summary.email')"
    :z-index="9999"
    :close-dialog-tool-tip="$t('popup.close')"
    qaid="customization-share-email-dialog"
    @opened="focusTrapShareEmailDialog"
    @keydown="handleKeydown"
    @close="closeModal"
  >
    <customization-share-email-body />
  </pdl-dialog>
</template>

<script>
import {mapMutations, mapState} from 'vuex';
import {PdlDialog} from '@pedal/pdl-dialog';
import CustomizationShareEmailBody from '@/components/containers/buy-zone/customization/CustomizationShareEmailBody.vue';
import {focusTrap, getAllFocusableElements} from '@/utils/accessibility/a11y-utils';

export default {
  name: 'CustomizationShareEmailDialog',
  components: {PdlDialog, CustomizationShareEmailBody},
  data() {
    return {
      focusableElements: [],
    };
  },
  computed: {
    ...mapState('bikeCustomization', ['isCustomizationShareEmailDialogOpen']),
    isVisible: {
      get() {
        return this.isCustomizationShareEmailDialogOpen;
      },
      set(value) {
        this.setIsCustomizationShareEmailDialogOpen(value);
      },
    },
  },
  watch: {
    isVisible(val) {
      this.setIsDialogOpen(val);
    },
  },

  methods: {
    ...mapMutations('bikeCustomization', [
      'setIsCustomizationShareEmailDialogOpen',
      'setIsDialogOpen',
      'clearQueuedShareAction',
    ]),

    closeModal() {
      this.clearQueuedShareAction();
      this.setIsCustomizationShareEmailDialogOpen(false);
    },
    focusTrapShareEmailDialog() {
      const dialog = document.querySelector('#customization-share-email-dialog');
      this.focusableElements = getAllFocusableElements(dialog);
    },
    handleKeydown(event) {
      focusTrap(event, this.focusableElements);
    },
  },
};
</script>
